exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".replace-enter{opacity:0}.replace-enter.drop-enter-active{opacity:1;transition:all .125s ease-in-out .125s}.replace-leave{opacity:1}.replace-leave.replace-leave-active{opacity:0;transition:all .125s ease-in-out}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/transitions/replace/styles.scss
// module id = 1089
// module chunks = 0